import React, { useState, useEffect } from 'react'

// const STORAGE_PREF_GAME = 'popex_preferred_game'
const STORAGE_SHOOTER_HIGH = 'captain_popx_high_score'
// const STORAGE_TERRA_HIGH = 'popex_terra_high_score'

const SkeletonGamePrompt = ({ onStartGame }) => {
  const [selectedGame] = useState('captain-popx')
  const [shooterHighScore, setShooterHighScore] = useState(0)

  useEffect(() => {
    try {
      setShooterHighScore(parseInt(localStorage.getItem(STORAGE_SHOOTER_HIGH), 10) || 0)
    } catch (e) {}
  }, [])

  return (
    <div className='skeleton-game-prompt'>
      <div className='skeleton-game-prompt__card'>
        {/* Game Mode Tabs - Terra Explorer commented out
        <div className='skeleton-game-prompt__tabs'>
          <button
            type='button'
            className='skeleton-game-prompt__tab'
            onClick={() => handleSelectGame('terra-explorer')}
          >
            🌍 Terra Explorer
          </button>
          <button
            type='button'
            className='skeleton-game-prompt__tab active'
            onClick={() => handleSelectGame('captain-popx')}
          >
            🚀 Captain PopX
          </button>
        </div>
        */}

        <div className='skeleton-game-prompt__body'>
          <div className='skeleton-game-prompt__icon-box'>
            🚀
          </div>

          <div className='skeleton-game-prompt__content'>
            <h4 className='skeleton-game-prompt__title'>
              Captain PopX
            </h4>
            <p className='skeleton-game-prompt__desc'>
              Retro space shooter with PopEx interceptor craft!
              {shooterHighScore > 0 && (
                <> • Best: <strong>{shooterHighScore.toLocaleString()} pts</strong></>
              )}
            </p>
          </div>

          <button
            type='button'
            className='skeleton-game-prompt__btn'
            onClick={() => onStartGame(selectedGame)}
          >
            Play Now ⚡
          </button>
        </div>
      </div>
    </div>
  )
}

export default SkeletonGamePrompt
